
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

export default function CartWithWhatsApp({
  items = [],
  ownerPhone,
  currency = "$",
  title = "",
  dell
}) {
  const { t } = useTranslation();
  const temp=[...items]
  const total=temp[0].total
  temp.shift()


  const normalizePhone = (p) => (p || "").replace(/[^\d]/g, "");

  const buildMessage = (values) => {
    const lines = [];
    lines.push(`*${title}*`);
    lines.push("");
    lines.push("*פרטי המזמין:*");
    lines.push(`שם: ${values.fullName}`);
    lines.push(`טלפון: ${values.phone}`);
    lines.push(`איסוף/משלוח: ${values.deliveryMethod === "pickup" ? "איסוף עצמי" : "משלוח"}`);
    if (values.deliveryMethod === "delivery" && values.address) {
      lines.push(`כתובת: ${values.address}`);
    }
    if (values.when) lines.push(`מתי: ${values.when}`);
    if (values.notes) lines.push(`הערות: ${values.notes}`);

    lines.push("");
    lines.push("*פרטי ההזמנה:* ");
    temp.forEach((it, idx) => {
      const lineTotal = Number(it.Price || 0) * Number(it.quantity || 0);
      lines.push(`${idx + 1}. ${it.name} — כמות: ${it.quantity} × ${currency}${Number(it.Price).toFixed(2)} = ${currency}${lineTotal.toFixed(2)}`);
    });
    lines.push(`\nסה"כ: *${currency}${total.toFixed(2)}*`);

    return lines.join("\n");
  };

  const initialValues = {
    fullName: "",
    phone: "",
    deliveryMethod: "pickup", // "pickup" | "delivery"
    address: "",

    notes: "",
  };

  const validationSchema = Yup.object({
    fullName: Yup.string().trim().required("שדה חובה"),
    phone: Yup.string()
      .trim()
      .matches(/^[0-9+\-()\s]{7,}$/u, "מספר לא תקין")
      .required("שדה חובה"),
    deliveryMethod: Yup.mixed().oneOf(["pickup", "delivery"]).required(),
    address: Yup.string().when("deliveryMethod", {
      is: "delivery",
      then: (schema) => schema.trim().required("יש למלא כתובת למשלוח"),
      otherwise: (schema) => schema.notRequired(),
    }),

    notes: Yup.string().max(300, "עד 300 תווים"),
  });

  const handleSubmit = (values) => {
    if (!ownerPhone || !temp?.length) return;
    const msg = buildMessage(values);
    const phoneForURL = normalizePhone(ownerPhone);
    const url = `https://wa.me/${phoneForURL}?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    dell();
  };

  const isCartEmpty = !temp || temp.length === 0;

  return (
    <div dir="rtl" className="container my-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h2 className="h4 fw-bold mb-3 text-center">{t("new_order")}</h2>

          {/* Cart */}
          <div className="mb-4">
            <h3 className="h6 fw-semibold mb-2 text-center">{t("cart_title")} </h3>
            {isCartEmpty ? (
              <div className="alert alert-secondary mb-2"> {t("cart_empty")}</div>
            ) : (
              <ul className="list-group mb-2">
                {temp.map((it,idx) => (
                  <li key={idx} className="list-group-item d-flex justify-content-between align-items-start">
                    <div className="me-3">
                      <div className="fw-semibold text-truncate">{it[t("name_for_choose")]}</div>
                      <small className="text-muted">
                        {t("quantity")}: {it.quantity} {t("price_f_u")}: {currency}
                        {Number(it.Price).toFixed(2)}
                      </small>
                    </div>
                    <div className="fw-bold">
                      {currency}
                      {(Number(it.Price) * Number(it.quantity)).toFixed(2)}
                    </div>
                  </li>
                ))}
              </ul>
            )}
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted">{t("total_to_pay")}</span>
              <span className="fs-5 fw-bold">{currency}{total.toFixed(2)}</span>
            </div>
          </div>

          {/* Formik Form */}
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ values, isSubmitting, isValid }) => (
              <Form>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label"> {t("full_name")}</label>
                    <Field name="fullName" className="form-control" placeholder={t("family_name")} />
                    <div className="form-text text-danger"><ErrorMessage name="fullName" /></div>
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label">{t("phone_order")} </label>
                    <Field name="phone" className="form-control" placeholder="(___)___-____" inputMode="tel" />
                    <div className="form-text text-danger"><ErrorMessage name="phone" /></div>
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label">  {t("delivery_or_pickup")}</label>
                    <div className="d-flex gap-3 align-items-center" >
                      <label className="form-check form-check-inline">
                        <Field type="radio" name="deliveryMethod" value="pickup" className="form-check-input" />
                        <span className="form-check-label">{t("pickup")}</span>
                      </label>
                      <label className="form-check form-check-inline">
                        <Field  type="radio" name="deliveryMethod" value="delivery" className="form-check-input" />
                        <span className="form-check-label" dir="ltr">{t("delivery")}</span>
                      </label>
                    </div>
                    <div className="form-text text-danger"><ErrorMessage name="deliveryMethod" /></div>
                  </div>

                  {values.deliveryMethod === "delivery" && (
                    <div className="col-12">
                      <label className="form-label"> {t("address")}</label>
                      <Field dir="ltr" name="address" className="form-control" placeholder={t("address_details")} />
                      <div className="form-text text-danger"><ErrorMessage name="address" /></div>
                    </div>
                  )}



                  <div className="col-12 col-md-6">
                    <label className="form-label">{t("notes")}</label>
                    <Field name="notes" className="form-control" placeholder={t("write_notes_here")} />
                    <div className="form-text text-danger"><ErrorMessage name="notes" /></div>
                  </div>
                </div>

                <div className="d-flex flex-column flex-md-row gap-2 mt-4">
                  <button
                    type="submit"
                    className="btn btn-success btn-lg"
                    disabled={isSubmitting || !isValid || isCartEmpty || !ownerPhone}
                    title={!ownerPhone ? "חסר ownerPhone" : undefined}
               
                  >
                   {t("send_order_whatsapp")}
                  </button>
                  {(!ownerPhone) && (
                    <div className="text-danger small">חסר ownerPhone (מספר וואטסאפ שלך). העבר prop תקין בלי פלוס, למשל 972501234567.</div>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div >
          <div className="d-flex justify-content-center align-items-center">
             <a 
              href={`https://venmo.com/israel-kitchen?txn=charge=${total}&note=Payment%20for%20food`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary align-content-center m-3"
              >
              {t("pay_with_venmo")}              
            </a>
          </div>
      </div>
    </div>
  );
}
